import { render, staticRenderFns } from "./LootboxRoll.vue?vue&type=template&id=e21f10e0&scoped=true&"
import script from "./LootboxRoll.vue?vue&type=script&lang=js&"
export * from "./LootboxRoll.vue?vue&type=script&lang=js&"
import style0 from "./LootboxRoll.vue?vue&type=style&index=0&id=e21f10e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21f10e0",
  null
  
)

export default component.exports